import route from "@/components/router/Router";

export default {
    path : "company-area-setting",
    name : "company-area-setting",
    meta : {
        title : "企业区域管理",
    },
    redirect : {
        name : "company-area-setting-edit",
    },
    component: route,
    children : [
        {
            path: 'edit',
            name: 'company-area-setting-edit',
            meta: {
                title: '企业区域管理-单位管理'
            },
            component: () => import('@/pages/company/companyArea/Index'),
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/company/companyArea/index.js